import marketDomain from './domain';

export const domain = marketDomain;
